"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _nanoid = require("nanoid");
const _globals = require("~/utils/globals");
const log = (message)=>{
    console.log(`nc_055_integration: ${message}`);
};
let hrTime = process.hrtime();
const logExecutionTime = (message)=>{
    const [seconds, nanoseconds] = process.hrtime(hrTime);
    const elapsedSeconds = seconds + nanoseconds / 1e9;
    log(`${message} in ${elapsedSeconds}s`);
};
const up = async (knex)=>{
    const nanoidv2 = (0, _nanoid.customAlphabet)('1234567890abcdefghijklmnopqrstuvwxyz', 14);
    if (!await knex.schema.hasTable(_globals.MetaTable.INTEGRATIONS)) {
        await knex.schema.createTable(_globals.MetaTable.INTEGRATIONS, (table)=>{
            table.string('id', 20).primary();
            table.string('title', 128);
            table.text('config');
            table.text('meta');
            table.string('type', 20).index();
            table.string('sub_type', 20);
            table.boolean('is_private').defaultTo(false);
            table.boolean('deleted').defaultTo(false);
            table.string('created_by', 20).index();
            table.float('order');
            table.timestamps(true, true);
        });
    }
    if (!await knex.schema.hasColumn(_globals.MetaTable.SOURCES_OLD, 'fk_integration_id')) {
        await knex.schema.alterTable(_globals.MetaTable.SOURCES_OLD, (table)=>{
            table.string('fk_integration_id', 20).index();
        });
    }
    hrTime = process.hrtime();
    // get all external sources, add them to integrations table and map back to bases
    const sources = await knex(_globals.MetaTable.SOURCES_OLD).select(`${_globals.MetaTable.SOURCES_OLD}.*`).select(`${_globals.MetaTable.PROJECT_USERS}.fk_user_id as created_by`).innerJoin(_globals.MetaTable.PROJECT, `${_globals.MetaTable.SOURCES_OLD}.base_id`, `${_globals.MetaTable.PROJECT}.id`).where((qb)=>qb.where(`${_globals.MetaTable.SOURCES_OLD}.is_meta`, false).orWhereNull(`${_globals.MetaTable.SOURCES_OLD}.is_meta`)).leftJoin(_globals.MetaTable.PROJECT_USERS, (qb)=>{
        qb.on(`${_globals.MetaTable.PROJECT}.id`, `${_globals.MetaTable.PROJECT_USERS}.base_id`).andOn(`${_globals.MetaTable.PROJECT_USERS}.roles`, knex.raw('?', [
            _nocodbsdk.ProjectRoles.OWNER
        ]));
    });
    logExecutionTime('Fetched external sources');
    hrTime = process.hrtime();
    for (const source of sources){
        const integrationId = `int${nanoidv2()}`;
        const integration = {
            title: source.alias,
            id: integrationId,
            config: source.config,
            type: _nocodbsdk.IntegrationsType.Database,
            sub_type: source.type,
            created_by: source.created_by,
            created_at: source.created_at,
            updated_at: source.updated_at
        };
        await knex(_globals.MetaTable.INTEGRATIONS).insert(integration);
        await knex(_globals.MetaTable.SOURCES_OLD).where('id', source.id).update({
            fk_integration_id: integrationId
        });
    }
    logExecutionTime('Migrated external sources');
};
const down = async (knex)=>{
    await knex.schema.dropTable(_globals.MetaTable.INTEGRATIONS);
    await knex.schema.alterTable(_globals.MetaTable.SOURCES_OLD, (table)=>{
        table.dropColumn('fk_integration_id');
    });
};
